// Date helpers shared by the Visibility Tracker dashboards.
//
// These were copy-pasted in three pages (AiCosts, OperatorMetrics, Pipeline) —
// identical implementations that drifted apart in nothing but their comments.
// `fmtDateTime` lived only in OperatorMetrics and is needed by any dashboard
// that shows a "last activity" column, so it moves here too.
//
// Deliberately LOCAL dates, not `toISOString().slice(0,10)`: the pickers show
// the user's calendar day, and in UTC+2 an evening `toISOString()` already reads
// as tomorrow.

export function todayISO() {
	const d = new Date()
	return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

export function isoMinusDays(n) {
	const d = new Date()
	d.setDate(d.getDate() - n)
	return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

// "2026-08-10 14:32" from an ISO timestamp.
//
// Kept BYTE-FOR-BYTE as it was in OperatorMetrics: the date part is UTC
// (`toISOString`) while the time part is the viewer's local clock
// (`toTimeString`). That mix is odd — around midnight in UTC+2 the two halves
// disagree by a day — but it is the behaviour the operators' dashboard has
// shipped with, and changing it here would silently move a column that nobody
// asked to move. Fix it as its own change if it ever bites.
export function fmtDateTime(iso) {
	if (!iso) return '—'
	try {
		const d = new Date(iso)
		return `${d.toISOString().slice(0, 10)} ${d.toTimeString().slice(0, 5)}`
	} catch { return iso }
}
